import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " Êtes vous sûr(e) de vouloir supprimer le choix : ", -1)
const _hoisted_4 = { class: "p-3 rounded bg-light font-weight-bold" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Annuler ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Supprimer ")

import { ref } from "vue";
import axios from "@/api";
import Button from "primevue/button";
import ActionDialog, { type ActionProps } from "./ActionDialog.vue";
import { useAlert } from "@/composables/alert";
import { Choice } from "@/types/index.js";

interface ChoiceRemoveProps extends ActionProps {
    choice: Choice;
    campaignId: ActionProps['campaignId']; // obligé de re déclarer car "extends" ou "&" ne fonctionnent pas (limitation de version Vue)
}


export default /*#__PURE__*/_defineComponent({
  props: {
    choice: null,
    campaignId: null
  },
  emits: ["remove"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'remove'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    choice: Choice;
    campaignId: ActionProps['campaignId']; // obligé de re déclarer car "extends" ou "&" ne fonctionnent pas (limitation de version Vue)
}





const mount = ref(false);
const isOpen = ref(false);
const alert = useAlert();

function openForm(): void {
    if (false === mount.value) {
        mount.value = true;
    }

    isOpen.value = true;
}

function onSubmit() {
    axios.delete(`/choices/${props.choice.id}`)
        .then(() => {
            alert.value = {
                status: 'success',
                summary:'Le choix a été supprimé avec succès',
            };
        })
        .catch(({ response }) => {
            alert.value = {
                status: (409 === response.status) ? 'conflict' : 'error',
                detail: (409 === response.status) ? response.data['hydra:description'] : undefined
            };
        });
}

function onHide() {
    if (alert.value && alert.value.status === 'success') {
        emit('remove');
    }

    alert.value = null;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(onSubmit, ["prevent"])
  }, [
    _createVNode(_unref(Button), {
      onClick: openForm,
      class: "p-button-text p-button-secondary",
      "aria-label": `Remove ${__props.choice.name}`,
      "aria-haspopup": "dialog"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["aria-label"]),
    (mount.value)
      ? (_openBlock(), _createBlock(ActionDialog, {
          key: 0,
          visible: isOpen.value,
          "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((isOpen).value = $event)),
          header: "Attention",
          alert: _unref(alert),
          "campaign-id": props.campaignId,
          onHide: onHide
        }, {
          footer: _withCtx(() => [
            _createVNode(_unref(Button), {
              onClick: _cache[0] || (_cache[0] = ($event: any) => {isOpen.value = false;}),
              class: "p-confirm-dialog-reject p-button-secondary p-button-outlined"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_unref(Button), {
              type: "submit",
              class: "p-button-danger",
              autofocus: ""
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _hoisted_3,
            _createElementVNode("p", _hoisted_4, _toDisplayString(__props.choice.name), 1)
          ]),
          _: 1
        }, 8, ["visible", "alert", "campaign-id"]))
      : _createCommentVNode("", true)
  ], 40, _hoisted_1))
}
}

})